module.exports = __webpack_public_path__ + "img/SP-Profi13_Overview-Rear_1.d549e18f.jpg";